import {
  LOGIN_USER,
  LOGOUT_USER,
  FETCH_PERSISTED_USER,
  UPDATE_USER_PROFILE,
  GHOST_USER,
} from '../actions/types';

export default (state = null, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return action.payload;
    case LOGOUT_USER:
      localStorage.removeItem('user');
      return null;
    case FETCH_PERSISTED_USER:
      return action.payload;
    case UPDATE_USER_PROFILE:
      const user = JSON.parse(localStorage.getItem('user'));
      const updatedUser = {
        jwt: user.jwt,
        user: action.payload,
      };
      localStorage.setItem('user', JSON.stringify(updatedUser));
      return { ...state, user: action.payload };
    case GHOST_USER:
      const newState = { ...state, ...action.payload };
      localStorage.setItem('user', JSON.stringify(newState));
      return newState;
    default:
      return state;
  }
};
